// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--q8fg48LQHkF9Nz5q"};